export const ECustomerPaymentType = {
  WithInDebit: 0,

  WithOutDebit: 1,

  All: 2,
} as const

export type ECustomerPaymentType = (typeof ECustomerPaymentType)[keyof typeof ECustomerPaymentType]
